<template>
  <div class="results">
    <SiestaHeader />
    <div class="vertical-spacer top-spacer"></div>
    <p class="you-did-it">{{msg}}</p>
    <div class="vertical-spacer"></div>
    <p class="score">Score {{ game.points.toLocaleString() }}</p>
    <form @submit.prevent="onSubmitInitials" v-if="!submitted && !submitting">
      <div class="initials-input" v-if="!submitting">
        <span class="initials">Initials:</span>
        <input
          ref="initials"
          class="input"
          type="text"
          maxlength="3"
          v-bind:value="initials"
          @input="onInput"
        />
        <button class="submit" :disabled="!canPost()" type="submit">
          <img class="arrow-right" src="@/assets/arrow2.svg" alt />
        </button>
      </div>
      <h2 class="submitting-score" v-else>SUBMITTING SCORE...</h2>
    </form>
    <h5 class="submitting-score" v-if="submitted">Score Submitted!</h5>
    <router-link class="button" to="/leaderboard">Leaderboard</router-link>
    <br />
    <router-link class="button" to="/activity">Play Again</router-link>
    <SiestaFooter :points="game.points" class="challenge" :is-results="true" />
  </div>
</template>

<script>
import SiestaHeader from "@/components/SiestaHeader";
import SiestaFooter from "@/components/SiestaFooter";
import { request } from "@/store/request";
const url = "/api/leaderboard";
const MAX_INITIALS = 3;

export default {
  name: "results",
  data() {
    return { submitting: false, err: "" };
  },
  components: {
    SiestaHeader,
    SiestaFooter
  },
  computed: {
    game() {
      return this.$store.state.game;
    },
    msg() {
      const items = [
        "YOU’RE A SIESTA SLEUTH!",
        "TIME’S UP! GREAT WORK.",
        "YOU CRUSHED IT!",
        "WOW! YOU’RE FAST!",
        "YOU’RE A SIESTA EXPERT."
      ];
      const index = Math.floor(Math.random() * items.length);
      return items[index];
    },
    initials: {
      get() {
        return this.game.initials;
      },
      set(initials) {
        this.game.initials = initials;
      }
    },
    submitted: {
      get() {
        return this.game.submitted;
      },
      set(submitted) {
        this.game.submitted = submitted;
      }
    }
  },
  methods: {
    canPost() {
      return this.initials.length >= 2 && this.initials.length <= MAX_INITIALS;
    },
    onInput(e) {
      let val = e.target.value.replace(/[^a-z]*/gi, "").toUpperCase();
      if (val.length > MAX_INITIALS) {
        val = val.substr(0, MAX_INITIALS);
      }
      this.initials = val;
      e.target.value = val;
    },
    async onSubmitInitials() {
      const payload = { initials: this.initials, score: this.game.points };
      this.submitting = true;
      try {
        const result = await request(`${url}/post`, "POST", payload);
        if (result.success) {
          this.submitted = true;
        }
      } catch {
        this.err =
          "There was a problem posting your score. Please try again later.";
      }
      this.submitting = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.results {
  padding: rems(24px) rems(24px) rems(32px) rems(24px);
  position: relative;
  text-align: center;
}
.you-did-it,
.score {
  font-size: rems(60px);
  letter-spacing: rems(6px);
  text-transform: uppercase;
}
.score {
  margin: rems(20px) 0;
  letter-spacing: rems(2px);
}
.submitting-score {
  font-size: rems(42px);
  letter-spacing: rems(2px);
  text-transform: uppercase;
  margin: rems(20px) 0;
}
.initials-input > * {
  margin: 0px rems(5px);
}
.initials-input {
  margin: rems(20px) 0;
  .submit {
    text-align: center;
    padding: 0;
  }
  .initials,
  .input,
  .submit {
    vertical-align: middle;
    font-size: rems(42px);
    letter-spacing: rems(0px);
    text-transform: uppercase;
    text-align: center;
    color: #fff;
  }
  .input,
  .submit {
    height: rems(66px);
    border: rems(1px) solid #fff;
    box-sizing: border-box;
  }
  .input {
    padding: 0;
    width: rems(140px);
    background-color: #5850a4;
  }
  .submit {
    width: rems(100px);
    background-color: #fff;
    color: #5850a4;
  }
  .submit:disabled {
    opacity: 0.5;
  }
}
.arrow-right {
  width: rems(50px);
  height: rems(30px);
}

.button {
  margin: 0 auto rems(10px) auto;
}
.challenge {
  margin-top: rems(32px);
}
</style>
